import React from 'react';
import { Link } from 'react-router-dom';

function ArticleProfile(props) {
  const fname = props.user.fname?.charAt(0).toUpperCase() + props.user.fname?.slice(1);
  const lname = props.user.lname?.charAt(0).toUpperCase() + props.user.lname?.slice(1);

  return (
    <div className="container">
      <div className="columns">
        <div className="column is-12">
          <div className='is-flex is-flex-direction-column is-align-items-center'>
            <figure className="image is-128x128">
              <img className='is-rounded pic-128' src={props.user?.image} alt='' />
            </figure>
            <p className='title ml-2 is-size-5'>{fname} {lname}</p>
          </div>
          <p className='mt-2 is-size-5'>Articles Created : {props.data?.length}</p>
          <div className="columns">
            <div className="column is-12 mt-5">
              <div className="columns is-flex is-justify-content-center">
                <Link to='/articles/new' className="button m-2 btn" style={{ width: '150px' }}>
                  <span className="icon is-small">
                    <i className="fas fa-newspaper"></i>
                  </span>
                  <span>Create Article</span>
                </Link>
                <Link to='/articles/user/articles' className="button m-2 btn" style={{ width: '150px' }}>
                  <span className="icon is-small">
                    <i className="fas fa-folder-open"></i>
                  </span>
                  <span>My Articles</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ArticleProfile;